import { render, staticRenderFns } from "./re-menu-sidebar.vue?vue&type=template&id=b854ed64"
import script from "./re-menu-sidebar.vue?vue&type=script&lang=ts"
export * from "./re-menu-sidebar.vue?vue&type=script&lang=ts"
import style0 from "./re-menu-sidebar.vue?vue&type=style&index=0&id=b854ed64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports